var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "row pointer notification mb-1",
        on: {
          click: function($event) {
            _vm.goToUrl(_vm.notification.id)
          }
        }
      },
      [
        _c("div", { staticClass: "col-11" }, [
          _c(
            "p",
            { class: [_vm.notification.read_at ? "" : "font-weight-bold"] },
            [
              _vm._v("\n        " + _vm._s(_vm.template) + "\n        "),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "timestamp" }, [
                _vm._v("\n          " + _vm._s(_vm.timestamp) + "\n        ")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-1" }, [
          _c("i", {
            class: [_vm.notification.read_at ? "" : "fa fa-circle blue"]
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7f8d864", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7f8d864","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationItem.vue
// module id = null
// module chunks = 